import { render, staticRenderFns } from "./IconIsDefault.vue?vue&type=template&id=3a9ff1c2&"
import script from "./IconIsDefault.vue?vue&type=script&lang=js&"
export * from "./IconIsDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports